export default "__VITE_ASSET__BTkdqZIZ__"